import { render, staticRenderFns } from "./TenancySustainabilityInitiatives.vue?vue&type=template&id=7b58e63f&scoped=true&"
import script from "./TenancySustainabilityInitiatives.vue?vue&type=script&lang=js&"
export * from "./TenancySustainabilityInitiatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b58e63f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b58e63f')) {
      api.createRecord('7b58e63f', component.options)
    } else {
      api.reload('7b58e63f', component.options)
    }
    module.hot.accept("./TenancySustainabilityInitiatives.vue?vue&type=template&id=7b58e63f&scoped=true&", function () {
      api.rerender('7b58e63f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/view/TenancySustainabilityInitiatives.vue"
export default component.exports